import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  Typography, Box, Stack, CircularProgress, Alert,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { generateSelfUpdateLink } from '../services/api';
import { useNotification } from '../hooks/useNotification';
import { openWhatsApp } from './patient-profile/patientProfileHelpers';

// Link de autocompletado de datos (patient_self_update). Compartido entre
// Patients.js ("Cargar datos de paciente nuevo" / "Generar link de
// actualización" en el menú de fila) y AppointmentDialog.js (ofrecerlo
// apenas se crea un paciente+turno desde la agenda) — antes vivía solo en
// Patients.js como componente privado, duplicarlo ahí hubiera sido el
// mismo diálogo dos veces. El recepcionista comparte el link a mano — el
// sistema nunca lo envía solo.
const SelfUpdateLinkDialog = ({ open, onClose, patientId, patientPhone }) => {
  const notify = useNotification();
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) { setUrl(''); setError(''); return; }
    setLoading(true);
    generateSelfUpdateLink(patientId)
      .then(res => setUrl(res.data.url))
      .catch(err => setError(err.userMessage || 'No se pudo generar el link'))
      .finally(() => setLoading(false));
  }, [open, patientId]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      notify('Link copiado', 'success');
    } catch {
      notify('No se pudo copiar — seleccioná el texto manualmente', 'error');
    }
  };

  const handleWhatsApp = () => {
    openWhatsApp(patientPhone, `Hola! Para confirmar tu turno completá tus datos acá: ${url}`);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Link para cargar datos</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress size={28} /></Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Compartiselo al paciente — vence en 48hs y solo se puede usar una vez.
            </Typography>
            <TextField fullWidth size="small" value={url} InputProps={{ readOnly: true }} sx={{ mb: 1.5 }} />
            <Stack direction="row" spacing={1}>
              <Button fullWidth variant="outlined" startIcon={<ContentCopyIcon />} onClick={handleCopy}>
                Copiar
              </Button>
              {patientPhone && (
                <Button fullWidth variant="contained" sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#1ebe57' } }}
                  startIcon={<WhatsAppIcon />} onClick={handleWhatsApp}>
                  WhatsApp
                </Button>
              )}
            </Stack>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelfUpdateLinkDialog;
